exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quantity[data-v-ea8f7dc6] {\n  padding-left: 0px;\n}\n", ""]);

// exports
